module.exports = __webpack_public_path__ + "img/logo-dcamp@3x.79135e46.png";